const loading = (state) => state.loading;

const isCustomerPage = (state) => state.isCustomerPage;

const filter = (state) => state.filter;

const emails = (state) => state.emails;

const pagination = (state) => state.pagination;

const accounts = (state) => state.accounts;

const unprocessedEmailCounts = (state) => state.unprocessedEmailCounts;

const templates = (state) => state.templates;

const templateById = (state) => (templateId) => state.templates.find((template) => template.id === templateId);

const selectedAccount = (state) => state.selectedAccount;

const firstSelectedEmail = (state) => state.selectedEmails[0];

const selectedEmails = (state) => state.selectedEmails;

const viewState = (state) => state.viewState;

const accountState = (state) => state.accountState;

const sendState = (state) => state.sendState;

const matchState = (state) => state.matchState;

export default {
  loading,
  isCustomerPage,
  filter,
  emails,
  pagination,
  accounts,
  unprocessedEmailCounts,
  templates,
  templateById,
  selectedAccount,
  firstSelectedEmail,
  selectedEmails,
  viewState,
  accountState,
  sendState,
  matchState,
};
